import React, {useState} from 'react';
import Input from "../UI/Input";
import Button from "../UI/Button";
import ErrorMessage from "../UI/ErrorMessage";

const CodeVerification = ({onSubmit, onBack, onError}) => {

    const [code, setCode] = useState();

    const handleSubmit = (e) => {
        e.preventDefault();
        onError && onError("");

        console.log(code);
        console.log(code.length);
        if(code.length < 6) {
            onError && onError("Codice non corretto");
        } else {
            if(onSubmit)
                onSubmit(code);
        }

    }

    return (
        <div>
            <div className="mx-4 p-4 bg-ea_green_from rounded-lg mt-4 flex flex-col ">
                <div>Inserisci il codice che ti è arrivato per email.</div>
                <form onSubmit={handleSubmit}>
                    <Input type="text"
                           className="uppercase"
                           placeholder="Codice"
                           label="Codice di Verifica"
                           required
                           onChange={(e) => setCode(e.target.value)}/>
                    <Button className="text-black mt-4" >Conferma</Button>
                </form>
            </div>

            <div className="cursor-pointer hover:underline text-sm mt-2 text-white" onClick={onBack}>Chiedi un nuovo codice</div>

        </div>
    );
};

export default CodeVerification;